import { useEffect } from "react";
import { useGoogleTagManager } from "./utils/useGoogleTagManager";
import "./index.scss";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const AppContainer = ({ children }) => {
  const { initializeGoogleTagManager } = useGoogleTagManager();

  useEffect(() => {
    initializeGoogleTagManager();
  }, [initializeGoogleTagManager]);

  return (
    <div className="app-container">
      <ReactHelmetWithProvider>
        <script type="text/javascript">
          {`
            script = document.createElement('script');
            script.onload = () => {
              Sailthru.init({
                customerId: '8107edbf17675b644eab070128fa6cf2',
                isCustom: true,
              });
            };
            script.src = 'https://ak.sail-horizon.com/spm/spm.v1.min.js';
            document.head.appendChild(script);
          `}
        </script>
      </ReactHelmetWithProvider>
      {children}
    </div>
  );
};
